/*
 * KT Cloud MarketPlace BackOffice version 1.0
 *
 *  Copyright ⓒ 2022 kt corp. All rights reserved.
 *
 *  This is a proprietary software of kt corp, and you may not use this file except in
 *  compliance with license agreement with kt corp. Any redistribution or use of this
 *  software, with or without modification shall be strictly prohibited without prior written
 *  approval of kt corp, and the copyright notice above does not evidence any actual or
 *  intended publication of such software.
 */
export const staParam = {
    namespaced: true,
    state: {
			paramObj:"",
			assetId:"",
			editMode:"",
			vueDummyYN:"",
			vueDummyY:"Y",
			vueDummyN:"N",
            assetParam:"",
            useParam:"",
            pageNo:"",
            product : {},
            productEntry : {},
            subscription : {},
            searchParams : {},
            productImageList : {},
    },

    mutations: {
        setParamObj(state, payload) {
            state.paramObj = payload
        },
        setPageNo(state, payload) {
            state.pageNo = payload
        },
        setAssetId(state, payload) {
            state.assetId = payload
				},
        setEditMode(state, payload) {
            state.editMode = payload
				},
        setVueDummyYN(state, payload) {
            state.vueDummyYN = payload
        },
        setAssetParam(state, payload) {
            state.assetParam = payload
        },
        setUseParam(state, payload) {
            state.useParam = payload
        },
        setProduct(state, payload) {
            state.product = payload
        },
        setProductEntry(state, payload) {
            state.productEntry = payload
        },
        setProductImageList(state, payload) {
            state.productImageList = payload
        },
        setSubscription(state, payload) {
            state.subscription = payload
        },
        setSearchParams(state, payload) {
            state.searchParams = payload
        },
    },

    actions: {
			//
    },

    getters: {
        getParamObj(state) {return state.paramObj},
        getPageNo(state) {return state.pageNo},
        getAssetId(state) {return state.assetId},
        getEditMode(state) {return state.editMode},
        getVueDummyYN(state) {return state.vueDummyYN},
        getVueDummyY(state) {return state.vueDummyY},
        getVueDummyN(state) {return state.vueDummyN},
        getAssetParam(state) {return state.assetParam},
        getUseParam(state) {return state.useParam},
        getProduct(state) {return state.product},
        getProductEntry(state) {return state.productEntry},
        getProductImageList(state) {return state.productImageList},
        getSubscription(state) {return state.subscription},
        getSearchParams(state) {return state.searchParams},
    }
};